import LandingSection from "./LandingSection";
import ProjectsSection from "./ProjectsSection";
import Promotion from "./Promotion";
import DownloadApp from "./DownloadApp";
import ComingSoon from "./ComingSoon";
import BlogSection from "./BlogSection";
import FaqSection from "./FaqSection";
import LendingOverviewSections from "./LendingOverviewSections";
import Disclosurre from "./disclosurre";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function Home() {
  const location = useLocation();
  
    useEffect(() => {
      if (location.hash) {
        const id = location.hash.replace('#', '');
        setTimeout(() => {
          const element = document.getElementById(id);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 100);
      }
    }, [location]);
    
  return (
    <main style={{ width: "100%", overflowX: "hidden" }}>   
      <LandingSection />
      <LendingOverviewSections />
      {/*<Promotion />*/}
      <FaqSection />
      {/*<BlogSection />*/}
      <Disclosurre />
    
    </main>
  );
}

export default Home;
